<template>
    <div class="view view--edit-profile">
        <edit-profile />
    </div>
</template>

<script>
    import editProfile from '../../components/EditProfile.vue';

    export default {
        components: {
            editProfile
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/auth/EditProfile.vue